export interface PersonalInfoFormFields {
  first_name: string;
  middle_initial?: string;
  last_name: string;
  email: string;
  date_of_birth: any;
  ssn: string;
}
export interface State {
  name: string;
  abbrev: string;
  id: string;
}
export interface AddressInfoFormFields {
  street_1: string;
  street_2: string;
  city: string;
  state: any;
  zip: string;
}

export interface BankFormFields {
  name: string;
  routing_number: string;
  account_number: string;
  account_type: string;
}

export interface FederalTaxFormFields {
  filing_status: string;
  dependents_amount: string;
  other_income: string;
  two_jobs: string;
  deductions: string;
  withholdingsOption?: string;
  extra_withholding: string;
}
export interface UserLayout {
  children?: React.ReactNode;
  title: string;
  hidePrevSection?: boolean;
  hideNext?: boolean;
  handleSubmit?: () => void;
  formRef?: any;
}

export interface TermsOfService {
  latest_terms_accepted: boolean;
}
export interface HomeAddress {
  employee_uuid: string;
  version: string;
  street_1: string;
  street_2?: string;
  city: string;
  state: string;
  zip: string;
}

export interface Compensation {
  id: number;
  uuid: string;
  job_id: number;
  version: string;
  rate: string;
  payment_unit: string;
  flsa_status: string;
}

export interface Location {
  street: string;
  street_line_2: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
}

export interface Job {
  uuid: string;
  employee_uuid: string;
  version: string;
  title: string;
  location_id: string;
  hire_date: string;
  rate: string;
  payment_unit: string;
  current_compensation_id: number;
  current_compensation_uuid: string;
  compensations: Compensation[];
  location: Location;
}

export interface PersonalInfo {
  id: number;
  employee_uuid: string;
  first_name: string;
  middle_initial?: string;
  last_name: string;
  email: string;
  version: string;
  terminated: boolean;
  two_percent_shareholder: boolean;
  onboarded: boolean;
  has_ssn: boolean;
  ssn: string;
  date_of_birth: string;
  home_address: HomeAddress;
  jobs: Job[];
}

export interface FederalTaxInfo {
  employee_uuid: string;
  version: string;
  w4_data_type: string;
  filing_status: string;
  extra_withholding: string;
  two_jobs: number;
  dependents_amount: string;
  other_income: string;
  deductions: string;
}

export interface Option {
  value: any;
  label: string;
}

export interface InputQuestionFormat {
  type: string;
  options: Option[];
}

export interface Answer {
  value: string;
  valid_from: string;
}

export interface Question {
  label: string;
  description: string;
  key: string;
  input_question_format: InputQuestionFormat;
  answers: Answer[];
}

export interface StateTaxes {
  employee_uuid: string;
  state: string;
  questions: Question[];
}
export interface Split {
  uuid: string;
  name: string;
  hidden_account_number: string;
  priority: number;
  split_amount: number;
}
export interface PaymentMethod {
  employee_uuid: string;
  version: string;
  type: string;
  split_by?: string;
  splits?: Split[];
  uuid?: string;
  name?: string;
}
export interface BankAccount {
  uuid: string;
  employee_uuid: string;
  name: string;
  routing_number: string;
  account_number: string;
  account_type: string;
}

export interface CompleteEmployeeDetails {
  personal_info: PersonalInfo;
  federal_tax_info: FederalTaxInfo;
  state_taxes: StateTaxes;
  payment_method: PaymentMethod;
  bank_accounts: BankAccount[];
}
export interface PdfResponse {
  uuid: string;
  document_url: string;
}

export interface ESignForm {
  uuid: string;
  name: string;
  title: string;
  description: string;
  requires_signing: boolean;
}

export enum UNSAVE_DIALOG_ACTIONS {
  SAVE = "save",
  DISCARD = "discard",
  KEEP_EDITING = "keep editing",
}

export interface BankFormFields {
  name: string;
  routing_number: string;
  account_number: string;
  account_type: string;
}

export enum PAYMENT_TYPES {
  check = "Check",
  directDeposit = "Direct Deposit",
}

export interface ESignFormData {
  signature_text : string
  agree: boolean
}